/**
 * Google Tag Manager utilities.
 * All dataLayer pushes use structured payloads with event, page_type, section, user_action
 * for seamless GA4 mapping. Existing user and custom attributes are preserved.
 */

const gtmUtils = {
  initializeGTM: () => {
    if (typeof window === 'undefined') return
    window.dataLayer = window.dataLayer || []
  },

  trackPageview: (pathname, title) => {
    if (typeof window === 'undefined') return
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'page_view',
      page_path: pathname,
      page_title: title,
      page_type: 'landing',
      section: 'main',
      user_action: 'view',
    })
    console.log('ckd_event_tracked -- page view --> ', {
      event: 'page_view',
      page_path: pathname,
      page_title: title,
      page_type: 'landing',
      section: 'main',
      user_action: 'view',
    })
  },

  /**
   * Pushes a structured event to dataLayer.
   * @param {Object} payload - Structured payload with event, page_type, section, user_action
   * @param {string} payload.event - Snake_case event name (e.g., ckd_quiz_complete)
   * @param {string} [payload.page_type] - Page context (e.g., landing, modal, result)
   * @param {string} [payload.section] - Section identifier (e.g., kidney_score, food_scan)
   * @param {string} [payload.user_action] - User action type (e.g., click, submit, view)
   * @param {Object} [payload.attributes] - Additional attributes (merged into payload, preserving existing)
   */
  trackEvent: (payload) => {
    if (typeof window === 'undefined' || !payload?.event) return
    window.dataLayer = window.dataLayer || []

    const { attributes = {}, ...structured } = payload
    const dataLayerPayload = {
      event: structured.event,
      ...(structured.page_type != null && { page_type: structured.page_type }),
      ...(structured.section != null && { section: structured.section }),
      ...(structured.user_action != null && {
        user_action: structured.user_action,
      }),
      ...attributes,
    }

    window.dataLayer.push(dataLayerPayload)
    console.log('ckd_event_tracked --->', dataLayerPayload)
  },

  setUserAttributes: (attributes = {}) => {
    if (typeof window === 'undefined') return
    window.dataLayer = window.dataLayer || []

    const { country_code, contact_no, ...rest } = attributes
    const userId =
      country_code && contact_no ? `${country_code}${contact_no}` : undefined

    const payload = {
      event: 'user_properties',
      ...rest,
    }
    if (userId) payload.user_id = userId

    window.dataLayer.push(payload)
  },
}

export default gtmUtils
